import BurgerMenu from 'components/BurgerMenu';
import DatePicker from 'components/DatePicker';
import LimitedTextarea from 'components/LimitedTextarea';
import ArenaWrapper from 'components/arena/ArenaWrapper';
import MentorListWrapper from 'components/mentors/MentorListWrapper';
import ProjectListWrapper from 'components/projects/ProjectListWrapper';
import AddMediaToProject from 'components/projects/AddMediaToProject';
import MemberWrapper from 'components/medlemmer/MemberWrapper';
import NewsListWrapper from 'components/news/NewsListWrapper';
import Comments from 'components/Comments';
import CommentForm from 'components/CommentForm';
import AvatarProfilePic from 'components/AvatarProfilePic';
import ArenaPreconfiguredWrapper, {
    makeAddAndRemoveFromProjectCallbackFactory,
} from 'components/arena/ArenaPreconfiguredWrapper';
import ArenaBarStandaloneWrapper from 'components/arena/ArenaBarStandaloneWrapper';
import TrafoPreview from 'components/TrafoPreview';
import ProjectFunds from 'components/ProjectFunds';
import BgSlider from 'components/frontpage/slider';
import Attachments from 'components/Attachments';
import AttachmentPreviewList from 'components/AttachmentPreviewList';
import EditWork from 'components/arena/EditWork';
import UploadWork from 'components/arena/UploadWork';
import arena from 'ducks/arena';
import memberlist from 'ducks/memberlist';
import mentorlist from 'ducks/mentorlist';
import newslist from 'ducks/newslist';
import projectlist from 'ducks/projectlist';
import { gettext } from './text';

/*
    routeMap expects:
    key (Django urlconf name e.g. qa:home, supports regex): {
        key (standard CSS-syntax, will render to all matching elements): {
            component: React component to render to element
            props (optional): Props to pass to component
            reducer (optional): Redux reducer for the Provider that wraps the component
        }
        excludeCommon: Whether to exclude common elements
    }
 */

export const setupCommonElements = () => ({
    '#burger-menu': {
        component: BurgerMenu,
        props: () => ({ links: DJ_CONST.BURGER_MENU_LINKS }),
    },
});

const fundingApplicationUpdate = {
    '.date-picker': {
        component: DatePicker,
        props: () => ({
            required: true,
        }),
    },
    '#project_costs-component': {
        component: ProjectFunds,
    },
    '#funding-component': {
        component: ProjectFunds,
        props: () => ({
            requiredElementDescription: gettext('Grant from Trafo'),
            requiredElementDefault: 10000,
        }),
    },
    '.limited-textarea': {
        component: LimitedTextarea,
        props: () => ({
            countLimit: 2000,
            countShow: true,
        }),
    },
};

const attachments = {
    component: Attachments,
    props: () => ({
        accept: DJ_CONST.validContentTypes,
        name: 'media',
        initialMediaItems: DJ_CONST.initialMediaItems,
    }),
};

const attachmentsPreview = {
    component: AttachmentPreviewList,
    props: () => ({
        mediaItems: DJ_CONST.relatedMediaItems,
    }),
};

const commentsBlock = {
    component: Comments,
    props: () => ({
        modelName: DJ_CONST.modelName,
        pk: DJ_CONST.commentedItem,
    }),
};

const commentFormBlock = {
    component: CommentForm,
    props: () => ({
        modelName: DJ_CONST.modelName,
        pk: DJ_CONST.commentedItem,
        acceptAttachments: DJ_CONST.acceptCommentAttachments,
        visibilityChoices: DJ_CONST.visibilityChoices,
    }),
};

export default {
    'trafo-frontpage': {
        ...setupCommonElements(),
        '#hero-slider': {
            component: BgSlider,
            props: () => ({
                images: DJ_CONST.frontPageImages,
                theme: DJ_CONST.frontPageSliderTheme || 'white',
                periodUntil: DJ_CONST.moneyPeriodUntil || '',
            }),
        },
        '#comments__guestmentor': {
            component: Comments,
            props: () => ({
                commentType: Comments.commentTypes.GUESTMENTOR,
                title: gettext('Guest mentor'),
                contentAndImageLinks: true,
            }),
        },
        '#comments__public': {
            component: Comments,
            props: () => ({
                commentType: Comments.commentTypes.PUBLIC,
                title: gettext('Comments by regular users'),
                contentAndImageLinks: true,
            }),
        },
    },
    'trafo-register': {
        '#birthdate-picker': {
            component: DatePicker,
            props: () => ({ required: true, provideDefaultDate: false }),
        },
    },
    trafo_fundingapplication_add: fundingApplicationUpdate,
    trafo_fundingapplication_details: fundingApplicationUpdate,
    trafo_fundingapplication_attachments: {
        '#attachments-component': attachments,
    },
    trafo_mentorapplication_attachments: {
        '#attachments-component': attachments,
    },
    trafo_fundingapplication_previewandaccept: {
        '#related-files-component': attachmentsPreview,
    },
    trafo_mentorapplication_previewandaccept: {
        '#related-files-component': attachmentsPreview,
    },
    trafo_fundingapplication_process: {
        '#related-files-component': attachmentsPreview,
        '.comments-component-root': commentsBlock,
        '.comments__form': commentFormBlock,
    },
    trafo_mentorapplication_process: {
        '#related-files-component': attachmentsPreview,
        '.comments-component-root': commentsBlock,
        '.comments__form': commentFormBlock,
    },
    trafo_arena_browse: {
        '#arena-wrapper': {
            component: ArenaWrapper,
            reducer: arena,
            props: () => ({
                filterChoices: DJ_CONST.filterChoices,
                selectedFilterKey: DJ_CONST.selectedFilterKey,
                selectedOrdering: DJ_CONST.selectedOrdering,
                query: DJ_CONST.query,
            }),
        },
    },
    trafo_arena_listmembers: {
        '#arena-wrapper': {
            component: MemberWrapper,
            reducer: memberlist,
            props: () => ({
                filterChoices: DJ_CONST.filterChoices,
                selectedFilterKey: DJ_CONST.selectedFilterKey,
                selectedOrdering: DJ_CONST.selectedOrdering,
                query: DJ_CONST.query,
            }),
        },
    },
    trafo_member_editprofile: {
        '.limited-textarea': {
            component: LimitedTextarea,
            props: () => ({
                countLimit: 1500,
                countShow: true,
            }),
        },
    },
    trafo_member_profile_with_seotitle: {
        '#arena-wrapper': {
            component: ArenaPreconfiguredWrapper,
            reducer: arena,
            props: () => ({
                filterChoices: DJ_CONST.filterChoices,
                selectedFilterKey: DJ_CONST.selectedFilterKey,
            }),
        },
    },
    trafo_arena_media_add: {
        '#media-upload-component': {
            component: UploadWork,
            props: () => ({
                accept: DJ_CONST.validContentTypes,
                textAlignOptions: DJ_CONST.textAlignOptions,
                textFontOptions: DJ_CONST.textFontOptions,
                textLineheightOptions: DJ_CONST.textLineheightOptions,
                initialValues: DJ_CONST.initialValues,
                errors: DJ_CONST.errors,
            }),
        },
    },
    trafo_arena_media_edit: {
        '#media-upload-component': {
            component: EditWork,
            props: () => ({
                objectId: DJ_CONST.objectId,
                accept: DJ_CONST.validContentTypes,
                textAlignOptions: DJ_CONST.textAlignOptions,
                textFontOptions: DJ_CONST.textFontOptions,
                textLineheightOptions: DJ_CONST.textLineheightOptions,
                privacyOptions: DJ_CONST.privacyOptions,
                initialValues: DJ_CONST.initialValues,
                errors: DJ_CONST.errors,
            }),
        },
    },
    trafo_arena_media_details_with_seotitle: {
        '#arena-wrapper': {
            component: ArenaPreconfiguredWrapper,
            reducer: arena,
            store: 'trafo_arena_media_details_with_seotitle-#arena',
            props: () => ({
                filterChoices: DJ_CONST.filterChoices,
                selectedFilterKey: DJ_CONST.selectedFilterKey,
                excludeItem: DJ_CONST.initialItem.id,
            }),
        },
        '#trafo-artwork-standalone-icon-bar': {
            component: ArenaBarStandaloneWrapper,
            reducer: arena,
            store: 'trafo_arena_media_details_with_seotitle-#arena',
            props: () => ({
                initialItem: DJ_CONST.initialItem,
                commentsLink: '#comments',
            }),
        },
        '#trafo-artwork__preview-target': {
            component: TrafoPreview,
            props: () => ({
                mediaItem: DJ_CONST.initialItem,
                size: 'large',
                showPreview: true,
                finishedLoadingCallback: DJ_CONST.initTrafoVideoAndAudio,
                showNewlyPublished: DJ_CONST.showNewlyPublished,
                showUnavailable: true,
            }),
        },
        '.comments-component-root': commentsBlock,
        '.comments__form': commentFormBlock,
    },
    trafo_application_mentoroverview: {
        '#mentors-wrapper': {
            component: MentorListWrapper,
            reducer: mentorlist,
            props: () => ({
                filterChoices: DJ_CONST.filterChoices,
                selectedFilterKey: DJ_CONST.selectedFilterKey,
                query: DJ_CONST.query,
            }),
        },
    },
    trafo_project_frontpage: {
        '#projects-wrapper': {
            component: ProjectListWrapper,
            reducer: projectlist,
            props: () => ({
                isAuthenticated: DJ_CONST.isAuthenticated,
            }),
        },
    },
    trafo_news_frontpage: {
        '#news-wrapper': {
            component: NewsListWrapper,
            reducer: newslist,
            props: () => ({
                filterChoices: DJ_CONST.filterChoices,
                selectedFilterKey: DJ_CONST.selectedFilterKey,
                query: DJ_CONST.query,
            }),
        },
    },
    trafo_news_details_with_seotitle: {
        '.comments-component-root': commentsBlock,
        '.comments__form': commentFormBlock,
    },
    trafo_project_details_with_seotitle: {
        '.comments-component-root': commentsBlock,
        '.comments__form': commentFormBlock,
        '#add-project-media-button': {
            component: AddMediaToProject,
            reducer: arena,
            store: 'trafo_project_details_with_seotitle-#arena',
        },
        '#arena-wrapper': {
            component: ArenaPreconfiguredWrapper,
            reducer: arena,
            store: 'trafo_project_details_with_seotitle-#arena',
            props: () => ({
                filterChoices: DJ_CONST.filterChoices,
                selectedFilterKey: DJ_CONST.selectedFilterKey,
                actionCallbackFactory: makeAddAndRemoveFromProjectCallbackFactory({
                    projectId: DJ_CONST.projectId,
                    user: DJ_CONST.user,
                    isParticipant: DJ_CONST.isParticipant,
                    projectIsActive: DJ_CONST.projectIsActive,
                }),
            }),
        },
    },
    trafo_member_editavatar: {
        '#upload-profile-pic': {
            component: AvatarProfilePic,
            props: () => ({
                accept: DJ_CONST.accept,
                initialAvatar: DJ_CONST.initialAvatar,
            }),
        },
    },
};



// WEBPACK FOOTER //
// ./src/utils/routeMap.js